<template>


    <main class="">

        <div class="px-4 pt-5 my-5 text-center border-bottom">
            <h1 class="display-4 fw-bold">Centered screenshot</h1>
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4">Quickly design and customize responsive mobile-first sites with Bootstrap, the world’s most popular front-end open source toolkit, featuring Sass variables and mixins, responsive grid system, extensive prebuilt components, and powerful JavaScript plugins.</p>
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
                    <button type="button" class="btn btn-primary btn-lg px-4 me-sm-3">Primary button</button>
                    <button type="button" class="btn btn-outline-secondary btn-lg px-4">Secondary</button>
                </div>
            </div>
            <div class="overflow-hidden" style="max-height: 22vh;">
                <div class="container px-5">
                    <img src="/img/arrows-g17f9cec7b_1920.jpg" class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy">
                </div>
            </div>
        </div>

        <header>
            <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
                <h1 class="display-4 fw-normal">Pricing</h1>
                <p class="fs-5 text-muted">Quickly build an effective pricing table for your potential customers with this Bootstrap example. It’s built with default Bootstrap components and utilities with little customization.</p>
            </div>
        </header>
        
        <div class="container">
            <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
                <div class="col">
                    <div class="card mb-4 rounded-3 shadow-sm">
                        <div class="card-header py-3">
                            <h4 class="my-0 fw-normal">Free</h4>
                        </div>
                        <div class="card-body">
                            <h1 class="card-title pricing-card-title">$0<small class="text-muted fw-light">/mo</small></h1>
                            <ul class="list-unstyled mt-3 mb-4">
                                <li>10 users included</li>
                                <li>2 GB of storage</li>
                                <li>Email support</li>
                                <li>Help center access</li>
                            </ul>
                            <button type="button" class="w-100 btn btn-lg btn-outline-primary">Sign up for free</button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card mb-4 rounded-3 shadow-sm">
                        <div class="card-header py-3">
                            <h4 class="my-0 fw-normal">Pro</h4>
                        </div>
                        <div class="card-body">
                            <h1 class="card-title pricing-card-title">$15<small class="text-muted fw-light">/mo</small></h1>
                            <ul class="list-unstyled mt-3 mb-4">
                                <li>20 users included</li>
                                <li>10 GB of storage</li>
                                <li>Priority email support</li>
                                <li>Help center access</li>
                            </ul>
                            <button type="button" class="w-100 btn btn-lg btn-primary">Get started</button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card mb-4 rounded-3 shadow-sm border-primary">
                        <div class="card-header py-3 text-bg-primary border-primary">
                            <h4 class="my-0 fw-normal">Enterprise</h4>
                        </div>
                        <div class="card-body">
                            <h1 class="card-title pricing-card-title">$29<small class="text-muted fw-light">/mo</small></h1>
                            <ul class="list-unstyled mt-3 mb-4">
                                <li>30 users included</li>
                                <li>15 GB of storage</li>
                                <li>Phone and email support</li>
                                <li>Help center access</li>
                            </ul>
                            <button type="button" class="w-100 btn btn-lg btn-primary">Contact us</button>
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="display-6 text-center mb-4">Compare plans</h2>

            <div class="table-responsive">
                <table class="table text-center">
                    <thead>
                        <tr>
                            <th style="width: 34%;"></th>
                            <th style="width: 22%;">Free</th>
                            <th style="width: 22%;">Pro</th>
                            <th style="width: 22%;">Enterprise</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" class="text-start">Public</th>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Private</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                    </tbody>

                    <tbody>
                        <tr>
                            <th scope="row" class="text-start">Permissions</th>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Sharing</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Unlimited members</th>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-start">Extra security</th>
                            <td></td>
                            <td></td>
                            <td><svg class="bi" width="24" height="24"><use xlink:href="#check"></use></svg></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="container px-4 py-5">
            <h2 class="pb-2 border-bottom">Features with title</h2>

            <div class="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-5">
                <div class="d-flex flex-column align-items-start gap-2">
                    <h3 class="fw-bold">Left-aligned title explaining these awesome features</h3>
                    <p class="text-muted">Paragraph of text beneath the heading to explain the heading. We'll add onto it with another sentence and probably just keep going until we run out of words.</p>
                    <a href="#" class="btn btn-primary btn-lg">Primary button</a>
                </div>
                <div class="row row-cols-1 row-cols-sm-2 g-4">
                    <div class="d-flex flex-column gap-2">
                        <div class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                            <svg class="bi" width="1em" height="1em">
                                <use xlink:href="#collection"></use>
                            </svg>
                        </div>
                        <h4 class="fw-semibold mb-0">Featured title</h4>
                        <p class="text-muted">Paragraph of text beneath the heading to explain the heading.</p>
                    </div>

                    <div class="d-flex flex-column gap-2">
                        <div class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                            <svg class="bi" width="1em" height="1em">
                                <use xlink:href="#gear-fill"></use>
                            </svg>
                        </div>
                        <h4 class="fw-semibold mb-0">Featured title</h4>
                        <p class="text-muted">Paragraph of text beneath the heading to explain the heading.</p>
                    </div>

                    <div class="d-flex flex-column gap-2">
                        <div class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                            <svg class="bi" width="1em" height="1em">
                                <use xlink:href="#speedometer"></use>
                            </svg>
                        </div>
                        <h4 class="fw-semibold mb-0">Featured title</h4>
                        <p class="text-muted">Paragraph of text beneath the heading to explain the heading.</p>
                    </div>

                    <div class="d-flex flex-column gap-2">
                        <div class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                            <svg class="bi" width="1em" height="1em">
                                <use xlink:href="#table"></use>
                            </svg>
                        </div>
                        <h4 class="fw-semibold mb-0">Featured title</h4>
                        <p class="text-muted">Paragraph of text beneath the heading to explain the heading.</p>
                    </div>
                </div>
            </div>
        </div>

    </main>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>